export default __webpack_public_path__ + "static/media/stop_circle.a6db66a3.svg";